import React, { Component } from 'react';

import { Button, Container } from 'reactstrap';
import CreateDmxDeviceForm from '../../components/Forms/CreateDmxDeviceForm';

class NewDmxDevice extends Component {
  goBack(event) {
    event.preventDefault();
    this.props.history.goBack();
  }

  render() {
    return (
      <div className="user-management">
        <Container fluid>
          <Button className="btn btn-primary waves-effect waves-light usersButtons" onClick={(event) => this.goBack(event)}>
            <i className="fas fa-arrow-left"></i>
          </Button>
          <CreateDmxDeviceForm />
        </Container>
      </div>
    );
  }
}

export default NewDmxDevice;
